export interface Article {
  id: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  coverImage: string;
  author: string;
  publishDate: string;
  readTime: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: 'art-001',
    title: '如何挑选最甜的西瓜？老瓜农传授5个秘诀',
    summary: '夏天到了，学会这5个挑选西瓜的技巧，保证你每次都能买到又甜又脆的好瓜。从看纹路到听声音，老瓜农的经验都在这里。',
    content: `<p>炎炎夏日，来一块冰镇西瓜是再幸福不过的事了。但是，买到不甜的西瓜也会让人大失所望。今天，瓜瓜基地请来了有30年种瓜经验的老瓜农张师傅，为大家分享挑选西瓜的5个黄金法则。</p>
<h4>一、看纹路</h4>
<p>好的西瓜表皮纹路清晰、分布均匀。瓜皮上的深绿色条纹越宽、越清晰，说明西瓜越成熟。如果纹路模糊不清或者颜色发暗，多半是还没熟透。</p>
<h4>二、看瓜脐</h4>
<p>瓜脐是西瓜底部的小圆圈。瓜脐越小，说明西瓜皮越薄，瓜肉越多。如果瓜脐很大，那这个西瓜可能皮厚肉少。</p>
<h4>三、看瓜蒂</h4>
<p>新鲜的西瓜瓜蒂应该是绿色的。如果瓜蒂已经干枯变褐色，说明采摘时间比较久了，新鲜度会打折扣。弯曲的瓜蒂比直的瓜蒂更甜哦！</p>
<h4>四、听声音</h4>
<p>用手指轻轻弹击西瓜，如果发出"咚咚"的清脆声音，说明西瓜已经成熟且水分充足。如果声音沉闷，可能是过熟了。如果声音太实，则可能还没熟。</p>
<h4>五、掂重量</h4>
<p>同样大小的西瓜，越重的说明水分越充足，吃起来更甜更脆。挑选时可以同时拿两个差不多大小的对比一下。</p>
<p>学会了这五招，你也能成为挑瓜高手！当然，如果不想费心挑选，直接来瓜瓜基地，我们每一颗瓜都经过专业筛选，保证甜蜜到家！</p>`,
    category: '挑选技巧',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20close%20up%20of%20a%20ripe%20watermelon%20being%20tapped%20by%20hand%20on%20a%20wooden%20farm%20table%2C%20warm%20sunlight%20streaming%20through%20a%20farm%20window%2C%20rustic%20farmhouse%20atmosphere%2C%20natural%20light%20photography%2C%20warm%20golden%20tones&width=1200&height=630&seq=article-art-001&orientation=landscape',
    author: '张师傅',
    publishDate: '2026-07-15',
    readTime: '5分钟',
    tags: ['西瓜', '挑选技巧', '生活妙招'],
  },
  {
    id: 'art-002',
    title: '哈密瓜的营养价值有多高？你可能不知道的5大好处',
    summary: '哈密瓜不仅香甜美味，还富含多种营养成分。揭秘哈密瓜的5大健康益处，让你吃得更放心。',
    content: `<p>哈密瓜被誉为"瓜中之王"，不仅因为它香甜的口感，更因为它丰富的营养价值。今天，我们就来揭秘哈密瓜的5大健康益处。</p>
<h4>一、富含维生素C</h4>
<p>每100克哈密瓜中含有约36毫克维生素C，是柠檬的1.5倍。维生素C能够增强免疫力，促进胶原蛋白合成，让皮肤更加光滑有弹性。</p>
<h4>二、丰富的β-胡萝卜素</h4>
<p>哈密瓜的橙色果肉中含有大量β-胡萝卜素，在体内可转化为维生素A，对保护视力、维持皮肤健康至关重要。每天吃一块哈密瓜，相当于给眼睛做了一次SPA。</p>
<h4>三、高钾低钠</h4>
<p>哈密瓜是典型的高钾低钠水果，钾含量高达267mg/100g。钾元素有助于维持体内电解质平衡，对控制血压、预防心血管疾病有积极作用。</p>
<h4>四、膳食纤维丰富</h4>
<p>哈密瓜中的膳食纤维能促进肠道蠕动，帮助消化。对于经常久坐的上班族来说，适量食用哈密瓜可以有效缓解便秘问题。</p>
<h4>五、天然抗氧化剂</h4>
<p>哈密瓜含有多种抗氧化物质，能够清除体内自由基，延缓衰老。经常食用哈密瓜，让你的身体由内而外散发健康光彩。</p>
<p>瓜瓜基地的哈密瓜全部来自新疆和甘肃优质产区，日照充足，自然成熟，营养更丰富！</p>`,
    category: '营养知识',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20arrangement%20of%20sliced%20orange%20hami%20melon%20on%20a%20rustic%20wooden%20board%2C%20surrounded%20by%20fresh%20mint%20leaves%2C%20warm%20natural%20sunlight%2C%20healthy%20food%20lifestyle%20concept%2C%20minimalist%20food%20photography%20with%20golden%20and%20green%20accents&width=1200&height=630&seq=article-art-002&orientation=landscape',
    author: '营养师小李',
    publishDate: '2026-07-10',
    readTime: '4分钟',
    tags: ['哈密瓜', '营养价值', '健康饮食'],
  },
  {
    id: 'art-003',
    title: '西瓜的创意吃法：5种让你惊艳的夏日甜品',
    summary: '西瓜不只是切块吃！分享5种创意西瓜甜品做法，让你的夏日餐桌充满惊喜。',
    content: `<p>西瓜是夏天最受欢迎的水果，但如果只会切块吃，那可就太可惜了！今天我们来分享5种创意十足的西瓜甜品做法，简单易学，颜值爆表。</p>
<h4>一、西瓜冰沙</h4>
<p>将西瓜切块去籽后冷冻4小时，取出放入搅拌机中打碎，加入少许蜂蜜和柠檬汁调味。装杯后点缀薄荷叶，一杯清凉解暑的西瓜冰沙就完成了！</p>
<h4>二、西瓜酸奶冻</h4>
<p>将西瓜汁和酸奶按2:1的比例混合，加入适量吉利丁片，倒入模具中冷藏凝固。脱模后撒上椰蓉，Q弹爽口的西瓜酸奶冻就做好了。</p>
<h4>三、西瓜披萨</h4>
<p>将西瓜横切成圆形厚片作为"饼底"，在上面铺上蓝莓、草莓、猕猴桃等时令水果，淋上酸奶代替芝士，撒上坚果碎，一道高颜值的水果披萨就完成啦！</p>
<h4>四、西瓜沙拉</h4>
<p>西瓜切块，搭配薄荷叶、菲达芝士和少许橄榄油，撒上黑胡椒和海盐。甜咸交织，清爽可口，是夏日聚会的绝佳开胃菜。</p>
<h4>五、西瓜冰棍</h4>
<p>将西瓜打成汁，过滤后加入少许椰奶，倒入冰棍模具，插入冰棍棒冷冻过夜。纯天然无添加，大人小孩都爱吃！</p>
<p>这些创意吃法是不是很简单？赶紧去瓜瓜基地下单新鲜西瓜，开始你的夏日甜品之旅吧！</p>`,
    category: '食谱分享',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20arrangement%20of%20creative%20watermelon%20desserts%20on%20a%20white%20marble%20table%2C%20including%20watermelon%20smoothie%20in%20a%20tall%20glass%2C%20watermelon%20popsicles%2C%20and%20fruit%20salad%2C%20bright%20summer%20vibes%2C%20natural%20lighting%2C%20food%20photography&width=1200&height=630&seq=article-art-003&orientation=landscape',
    author: '美食达人阿花',
    publishDate: '2026-07-05',
    readTime: '6分钟',
    tags: ['西瓜', '食谱', '夏日甜品'],
  },
  {
    id: 'art-004',
    title: '产地直采的秘密：一颗好瓜从田间到餐桌的旅程',
    summary: '从新疆的哈密瓜到山东的西瓜，揭秘瓜瓜基地产地直采的全流程，让你了解每一颗瓜背后的故事。',
    content: `<p>你有没有好奇过，你餐桌上的那颗香甜的瓜，经历了怎样的旅程？今天，我们带你走进瓜瓜基地的产地直采体系，看看一颗好瓜是如何从田间来到你家的。</p>
<h4>第一步：产地甄选</h4>
<p>瓜瓜基地的采购团队走遍全国优质瓜果产区，从新疆哈密的蜜瓜之乡到山东潍坊的西瓜基地，严格筛选气候条件优越、土壤肥沃的种植基地。我们只与拥有10年以上种植经验的农户合作。</p>
<h4>第二步：自然种植</h4>
<p>我们合作的所有种植基地都遵循自然农法，不使用催熟剂和膨大剂。每一颗瓜都在阳光下自然生长，充分吸收天地精华，直到自然成熟。</p>
<h4>第三步：严格筛选</h4>
<p>采摘前，我们的质检员会使用专业仪器检测甜度和成熟度。只有甜度达标、外观完好的瓜才能进入下一环节。我们坚持"不熟不采、不好不发"的原则。</p>
<h4>第四步：产地直发</h4>
<p>被选中的瓜果当天采摘、当天打包、当天发货。采用专业的水果保护包装，确保运输过程中不受损伤。我们与顺丰冷链合作，全国主要城市次日可达。</p>
<h4>第五步：新鲜到家</h4>
<p>从产地到你手中，全程不超过48小时。打开包装的那一刻，你闻到的就是来自田间地头最新鲜的瓜果香气。</p>
<p>这就是瓜瓜基地的承诺：从产地到餐桌，我们用心守护每一颗瓜的新鲜！</p>`,
    category: '品牌故事',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20farmland%20scene%20with%20rows%20of%20ripening%20melons%20in%20a%20field%20under%20golden%20sunlight%2C%20farmers%20carefully%20harvesting%20melons%2C%20distant%20mountains%20in%20background%2C%20warm%20atmospheric%20photography%2C%20golden%20hour%20light&width=1200&height=630&seq=article-art-004&orientation=landscape',
    author: '瓜瓜基地',
    publishDate: '2026-06-28',
    readTime: '5分钟',
    tags: ['产地直采', '品质保障', '品牌故事'],
  },
  {
    id: 'art-005',
    title: '不同品种的香瓜你吃过几种？香瓜家族大盘点',
    summary: '从玉菇甜瓜到绿宝石，从伊丽莎白到网纹瓜，带你认识香瓜家族的各位成员，看看你最爱哪种？',
    content: `<p>走进水果店，面对各式各样的香瓜，你是不是经常眼花缭乱？今天，瓜瓜基地就带你来一场香瓜家族大巡礼，教你认识每种香瓜的特点。</p>
<h4>玉菇甜瓜</h4>
<p>外形圆润，果皮淡绿带白，果肉浅绿色，口感如白玉般细腻，清香淡雅，甜而不腻。原产浙江嘉兴一带，是江南水乡的特色瓜果。</p>
<h4>绿宝石香瓜</h4>
<p>果皮翠绿如翡翠，果肉淡绿色，口感脆爽清甜，香气浓郁。河北保定特产，因外观如宝石般美丽而得名。</p>
<h4>伊丽莎白瓜</h4>
<p>金黄色外皮，果肉白色，口感绵软香甜，有淡淡的奶油香气。原产日本，引进中国后在各地广泛种植。</p>
<h4>网纹瓜</h4>
<p>表皮布满均匀的网纹，果肉橙黄色，甜度极高，口感软糯。日本静冈网纹瓜是世界最著名的甜瓜品种之一。</p>
<h4>羊角蜜</h4>
<p>外形细长如羊角，果皮淡黄，果肉淡绿色，脆甜清香。山东特产，近年来因其独特的造型和口感走红网络。</p>
<p>瓜瓜基地根据季节精选最优质的香瓜品种，让你在家就能尝遍全国好瓜！</p>`,
    category: '品种知识',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20flat%20lay%20arrangement%20of%20various%20types%20of%20cantaloupes%20and%20melons%20on%20a%20white%20marble%20surface%2C%20different%20colors%20and%20textures%20of%20rinds%2C%20some%20cut%20open%2C%20green%20leaves%20decoration%2C%20natural%20lighting%2C%20food%20photography&width=1200&height=630&seq=article-art-005&orientation=landscape',
    author: '农业专家王老师',
    publishDate: '2026-06-20',
    readTime: '5分钟',
    tags: ['香瓜', '品种知识', '水果科普'],
  },
  {
    id: 'art-006',
    title: '瓜果保鲜小妙招：这样储存多放一周也不坏',
    summary: '买回家的瓜果怎么存放才能保持新鲜？分享超实用的瓜果保鲜技巧，让你的瓜果多放一周依然新鲜如初。',
    content: `<p>买了一大堆新鲜瓜果回家，吃不完怎么办？别担心，瓜瓜基地整理了超实用的瓜果保鲜技巧，学会了可以大大延长瓜果的保鲜期。</p>
<h4>西瓜保鲜法</h4>
<p>整个西瓜放在阴凉通风处即可保存一周。切开的西瓜要用保鲜膜紧紧包裹切面，放入冰箱冷藏，最好在2天内吃完。切记不要反复从冰箱取出再放回，温差变化会加速变质。</p>
<h4>哈密瓜保鲜法</h4>
<p>未切开的哈密瓜放在室温阴凉处可保存3-5天。切开后去籽，用保鲜膜包好放入冰箱，可保存2-3天。建议吃之前半小时从冰箱取出，回温后口感更佳。</p>
<h4>香瓜保鲜法</h4>
<p>香瓜比较娇嫩，建议购买后3天内食用。整瓜用报纸包裹放入冰箱蔬果层。切开的香瓜一定要去籽，用保鲜盒密封冷藏。</p>
<h4>通用保鲜技巧</h4>
<p>1. 瓜果不要清洗后再存放，表面的天然蜡质是天然保护层；2. 瓜果不要和苹果、香蕉放在一起，这些水果释放的乙烯会加速瓜果成熟；3. 冰箱温度保持在4-8°C最适宜。</p>
<p>当然，最好的保鲜方法就是趁新鲜赶紧吃掉！瓜瓜基地保证每一颗瓜都是现采现发，新鲜度满满！</p>`,
    category: '生活妙招',
    coverImage: 'https://readdy.ai/api/search-image?query=Various%20fresh%20melons%20and%20fruits%20neatly%20stored%20in%20a%20clean%20refrigerator%20compartment%2C%20organized%20food%20storage%20concept%2C%20bright%20refrigerator%20interior%20lighting%2C%20fresh%20vibrant%20colors%2C%20lifestyle%20photography&width=1200&height=630&seq=article-art-006&orientation=landscape',
    author: '生活达人小美',
    publishDate: '2026-06-15',
    readTime: '3分钟',
    tags: ['保鲜技巧', '生活妙招', '食材储存'],
  },
];

export const articleCategories = ['全部文章', '挑选技巧', '营养知识', '食谱分享', '品牌故事', '品种知识', '生活妙招'];

export function getArticleById(id: string): Article | undefined {
  return articles.find((a) => a.id === id);
}

export function getRelatedArticles(currentId: string, count: number = 3): Article[] {
  return articles.filter((a) => a.id !== currentId).slice(0, count);
}